var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icon",
    clipPath: "url(#clip0_0_3021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 1.75C0 0.782031 0.797991 0 1.78571 0H23.2143C24.202 0 25 0.782031 25 1.75C25 2.71797 24.202 3.5 23.2143 3.5H1.78571C0.797991 3.5 0 2.71797 0 1.75ZM0 10.5C0 9.53203 0.797991 8.75 1.78571 8.75H23.2143C24.202 8.75 25 9.53203 25 10.5C25 11.468 24.202 12.25 23.2143 12.25H1.78571C0.797991 12.25 0 11.468 0 10.5ZM25 19.25C25 20.218 24.202 21 23.2143 21H1.78571C0.797991 21 0 20.218 0 19.25C0 18.282 0.797991 17.5 1.78571 17.5H23.2143C24.202 17.5 25 18.282 25 19.25Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu.f7a49c3458ff4b46b4577b70aef8dc95.svg";